import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { Debug } from '@awayjs/core';
// Class: GameInputControl
var GameInputControl = /** @class */ (function (_super) {
    __extends(GameInputControl, _super);
    function GameInputControl() {
        return _super.call(this) || this;
    }
    Object.defineProperty(GameInputControl.prototype, "numValues", {
        // _numValues: number /*int*/;
        // _index: number /*int*/;
        // _relative: boolean;
        // _type: string;
        // _hand: string;
        // _finger: string;
        // _device: flash.ui.GameInputDevice;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get numValues', '');
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "index", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get index', '');
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "relative", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get relative', '');
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "type", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get type', '');
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "hand", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get hand', '');
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "finger", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get finger', '');
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInputControl.prototype, "device", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInputControl', 'get device', '');
            return null;
        },
        enumerable: false,
        configurable: true
    });
    GameInputControl.prototype.getValueAt = function (index) {
        if (index === void 0) { index = 0; }
        index = index | 0;
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInputControl', 'getValueAt', '');
        return 0;
    };
    // Called whenever the class is initialized.
    GameInputControl.classInitializer = null;
    // List of static symbols to link.
    GameInputControl.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputControl.instanceSymbols = null; // [];
    return GameInputControl;
}(EventDispatcher));
export { GameInputControl };
